import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";

import { toast } from "react-toastify";

const AppPermissionsForm = (props) => {
  const frmRef = useRef({});
  const [orgData, setOrgData] = useState([]);
  const [orgId, setOrgId] = useState(0);
  const [appName, setAppName] = useState("");
  const [mobileServicesData, setMobileServicesData] = useState([]);

  const { sendRequest: getOrganization } = useHttp();

  const getOrgData = () => {
    getOrganization(
      {
        url: `/api/organisation/`,
      },
      (res) => {
        setOrgData(res);
      }
    );
  };

  useEffect(() => {
    getOrgData();
  }, []);

  const { sendRequest: getServiceData } = useHttp();
  useEffect(() => {
    getServiceData(
      {
        url: `/api/getMobileServicePermission/?orgId=${orgId}&appName=${appName}&createdBy=${localStorage.getItem(
          "id"
        )}`,
      },
      (res) => {
        //console.log(res);
        setMobileServicesData(res.mobileServicePermessionList);
      }
    );
  }, [appName, orgId]);

  const handleCheckboxChange = (index) => {
    const updatedMobileServicesData = [...mobileServicesData];
    updatedMobileServicesData[index].status =
      !updatedMobileServicesData[index].status;
    setMobileServicesData(updatedMobileServicesData);

  };

  const { sendRequest: postPermissions } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);
  

    const input = mobileServicesData&&mobileServicesData.map((item) => ({
      ...item,
      orgId: orgId,
      createdBy: parseInt(localStorage.getItem("id")),
    }));

   // console.log(input);

    postPermissions(
        {
          url: "/api/mobileServicePermission/",
          method: "POST",
          body: input,
        },
        (data) => {
          props.addForm(false);
      
          toast.success("Mobile App Permissions Updated");
        }
      );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Mobile App Permissions Form </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Organization Name</label>
                        <select
                          className="form-control"
                          style={{ width: "100%" }}
                          required
                          value={orgId}
                          onChange={(e) => {
                            setOrgId(e.target.value);
                            setAppName("");
                            setMobileServicesData("");
                          }}
                        >
                          <option value="">Select</option>
                          {orgData &&
                            orgData.map((x) => (
                              <option key={x.orgId} value={x.orgId}>
                                {x.orgName}
                              </option>
                            ))}{" "}
                        </select>
                      </div>
                    </div>
                    {/* /.col */}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>App Name</label>
                        <select
                          className="form-control"
                          style={{ width: "100%" }}
                          ref={(el) => (frmRef.current["app_name"] = el)}
                          required
                          value={appName}
                          onChange={(e) => {
                            setAppName(e.target.value);
                          }}
                        >
                          <option value="">Select</option>

                          <option value="Agri Promoter">
                          Agri Promoter
                          </option>
                          <option value="Commercial Farming">
                            Commercial Farming
                          </option>

                          <option value="Market Detail">
                            Market Detail
                          </option>

                          <option value="Sales">Sales</option>
                          <option value="Procurement">
                            Procurement
                          </option>

                           <option value="Seed Production">
                            Seed Production
                          </option>
                          
                          <option value="Warehouse Procurement">
                          Warehouse Procurement
                          </option>
                          <option value ="Nursery">
                          Nursery
                          </option>
                          <option value="Research Program">
                          Research Program
                          </option>
                          
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mx-5">
                      <div>
                        <div className="row">
                          <table className="table table-bordered text-center">
                            <thead>
                              <tr>
                                <th>Service Name</th>
                                <th> Service Access</th>
                              </tr>
                            </thead>
                            <tbody>
                              {mobileServicesData &&
                                mobileServicesData.map((itm, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{itm.serviceName}</td>
                                      <td>
                                        {" "}
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={"status"}
                                          checked={itm.status}
                                          onChange={() =>
                                            handleCheckboxChange(i)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AppPermissionsForm;
